/*
 Migrations file for the new text modal editor. This file is not intended
 for migrations between the legacy and the new text modal but for migrations
 for the existing modal.

 Migrations so far:
 - Gooey text effect.
 - Text color. There is an issue when color is expressed in a css value. It
 produces animations to fail, for that reason the migration will replace it with
 the corresponding rgba value when they are found.
*/
import { fromJS } from 'immutable';

import { gooeyTextMigration, textColorMigration } from './overlay-migrations';
import { TextOverlayV2 } from './types';

const applyMigrations = (overlay: TextOverlayV2): TextOverlayV2 => {
  return overlay.withMutations(s => {
    if (!s.get('advancedTextConfigs')) {
      s.set('advancedTextConfigs', fromJS({}));
    }

    if (!s.get('advancedAnimation')) {
      s.set('advancedAnimation', fromJS({}));
    }

    gooeyTextMigration(s);
    textColorMigration(s);
  });
};

export default applyMigrations;
